import Dropdown from 'rc-dropdown';
import Menu, { Item as MenuItem } from 'rc-menu';
import React, { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import 'rc-dropdown/assets/index.css';
import { faCheck, faSearch } from '@fortawesome/pro-solid-svg-icons';
import { ThreeDots } from 'react-loader-spinner';
import { faChalkboardUser } from '@fortawesome/free-solid-svg-icons';

const Index = ({
  value,
  dropdownId,
  selectedId,
  selectedName,
  groups,
  loadMoreData,
  selectedGroup,
  setSelectedGroup,
  isLoading,
  setSearchString,
  setSelectedDropDown,
  onChange,
  className
}) => {
  const [visible, setVisible] = useState(false);
  const menuRef = useRef();
  const [isAtBottom, setIsAtBottom] = useState(false);

  const handleVisibleChange = (visible) => {
    setVisible(visible);
  };

  const searchHandler = (searchString)=>{
    setSelectedDropDown(dropdownId);
    if (searchString.length === 0) {
      setSearchString('');
      return;
    }
    setSearchString(searchString);
  };

  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  };
  
  const handleScroll = () => {
    setSelectedDropDown(dropdownId);
    if (!menuRef.current) return;
    const { scrollTop, scrollHeight, clientHeight } = menuRef.current;
    if (scrollTop + clientHeight >= scrollHeight - 5 && !isAtBottom) {
      setIsAtBottom(true);
    }
  };

  useEffect(() => {
    if (isAtBottom) {
      setIsAtBottom(false);
      loadMoreData();
    }
  }, [isAtBottom]);

  useEffect(() => {
    if (menuRef.current) {
      menuRef.current.addEventListener('scroll', debouncedHandleScroll);
      return () => menuRef.current?.removeEventListener('scroll', debouncedHandleScroll);
    }
  }, [visible]);

  const handleGroupSelection = (type) => {
    setSelectedDropDown(dropdownId);
    if(type == selectedGroup)
      setSelectedGroup(null);
    else
      setSelectedGroup(type);
  };

  const debouncedHandleScroll = debounce(handleScroll, 200);

  const menu = (
    <div
      ref={menuRef}
      className='custom-scrollbar'>
      <Menu className='w-100 folder-dropdown' onSelect={(e) => { onChange(e); setVisible(false); }}>
        <div className="custom-search position-relative mb-3">
          <FontAwesomeIcon icon={faSearch} />
          <input type="text" 
            onChange={(e) => searchHandler(e.target.value)}
            className="form-control" />
        </div>
        <div className='d-flex justify-content-around pb-2'>
          {groups?.map((item, index) => (
            <div key={'g'+index} className='align-items-center d-flex gap-2 cursor-pointer' onClick={()=>handleGroupSelection(item.type)}>
              <span className='align-items-center d-flex justify-content-center rounded-circle grid-icon-btn' style={{backgroundColor: item.color}}>
                {item.icon}
              </span>
              <span className={`fs-6 ${selectedGroup == item.type && 'fw-semibold'}`} style={selectedGroup === item.type ? { color: item.color } : {}}>
                {item.name}
              </span>
            </div>
          ))}
        </div>
        <>
          {value.map((item, index) => (
            <MenuItem key={item.id} className={`${item.id == selectedId ? 'selected-value' : ''}`}>
              <div className='cursor-pointer form-check d-flex justify-content-between align-items-center'>
                <div className='align-items-center d-flex gap-2' htmlFor={'check-' + index}>
                  {(() => {
                    const selectedGroup = groups.find(x => x.type === item.type);
                    return (
                      <>
                        <span className='align-items-center d-flex justify-content-center rounded-circle grid-icon-btn' style={{ backgroundColor: selectedGroup?.color }}>
                          {selectedGroup?.icon}
                        </span>
                        <div className="d-flex align-items-center gap-2 text-truncate w-min-max-250 ">
                          <p
                            className="m-0"
                            dangerouslySetInnerHTML={{ __html: item.name }}
                          />

                          {item.teacherName?.length > 0 && (
                            <span className="badge badge-info fw-normal">
                              <FontAwesomeIcon icon={faChalkboardUser} className="me-1" />
                              {item.teacherName}
                            </span>
                          )}
                        </div>
                      </>
                    );
                  })()}
                </div>
                {item.id == selectedId && (
                  <div className='px-3'>
                    <FontAwesomeIcon className='green-tick' icon={faCheck} />
                  </div>
                )}
              </div>
            </MenuItem>
          ))}
          {isLoading && 
          <div className='d-flex justify-content-center'>
            <ThreeDots className='justify-content-center' height='15' width='100' color='grey'></ThreeDots>
          </div>}
        </>
      </Menu>
    </div>
  );

  return (
    <>
      <div id={dropdownId}>
        <Dropdown
          trigger={['click']}
          onVisibleChange={handleVisibleChange}
          visible={visible}
          closeOnSelect={true}
          overlay={menu}
          overlayClassName='dropdown-style'
          animation="slide-up"
          getPopupContainer={() => document.getElementById(dropdownId)}>
          <div className={`${className} form-select d-flex align-items-center`}>
            <div value={selectedId} className={`form-placeholder cursor-pointer overflow-hidden ${selectedName?.length > 65 ? ' fs-7' : ''}`}>
              <span dangerouslySetInnerHTML={{ __html: selectedName}}></span>
            </div>
          </div>
        </Dropdown>
      </div>
    </>
  );
};

Index.propTypes = {
  value: PropTypes.array,
  dropdownId: PropTypes.string,
  selectedId: PropTypes.string,
  selectedName: PropTypes.string,
  groups: PropTypes.array,
  loadMoreData: PropTypes.func,
  selectedGroup: PropTypes.number,
  setSelectedGroup: PropTypes.func,
  isLoading: PropTypes.bool,
  setSearchString: PropTypes.func,
  setSelectedDropDown: PropTypes.func,
  onChange: PropTypes.func,
  className: PropTypes.string
};

export default Index;
